import { apiGetMe } from '../../common/api/profile'
import {
  apiGetInvitations,
  apiRemoveCurrentInvitation,
  apiMarkAsSeen,
  apiMarkAsUnseen
} from '../../common/api/invitations'

const fetchCurrentInvitations = (params = {}) => ({
  requestPrefix: 'CURRENT_INVITATIONS:FETCH',
  request: () =>
    apiGetInvitations({
      scope: 'pending',
      include: `assessment_file_invitation.details,assessment_file_invitation.invited_by,assessment_file_invitation.account.names,assessment_file_invitation.guest_moderator,assessment_file_invitation.account.names,assessment_file_invitation.timestamps,assessment_file_invitation.assessment_file,assessment_file_invitation.assessment_file.details,assessment_file_invitation.assessment_file.policy,assessment_file_invitation.assessment_file.student_types.school,assessment_file_invitation.assessment_file.student_type.school.names,collection.order.desc,collection.limit.30,collection.page.${params.page ||
        1}`
    })
})

const fetchInvitationCounter = () => ({
  requestPrefix: 'CURRENT_INVITATIONS:FETCH_COUNTER',
  request: () =>
    apiGetMe({
      include: 'account.assessment_file_invitations_counter'
    })
})

const removeInvitation = (invitationId, seen) => ({
  requestPrefix: 'CURRENT_INVITATIONS:REMOVE',
  params: { id: invitationId, seen },
  request: () => apiRemoveCurrentInvitation(invitationId)
})

const markAsSeen = id => ({
  requestPrefix: 'CURRENT_INVITATIONS:MARK_AS_SEEN',
  params: { id },
  request: () => apiMarkAsSeen(id)
})

const markAsUnseen = id => ({
  requestPrefix: 'CURRENT_INVITATIONS:MARK_AS_UNSEEN',
  params: { id },
  request: () => apiMarkAsUnseen(id)
})

export {
  fetchCurrentInvitations,
  removeInvitation,
  fetchInvitationCounter,
  markAsSeen,
  markAsUnseen
}
